import Header from "components/Common/Header/Header";
import React, { useEffect } from "react";
import VaccinationListBody from "components/ClinicalManagement/Vaccination/VaccinationListBody";

const Vaccination = () => {
  useEffect(() => {
    document.title = "Vaccination Module";
  }, []);

  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="clinicalmanagement" />
      <VaccinationListBody />
    </main>
  );
};

export default Vaccination;
